// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"dd2680ea43f6040b","888":"cf8a3ebe013b9d86"}[chunkId] + ".css";
};